/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
( function() {
	var body, siteNav, menuToggle, menu, links, i, len;

	body = document.body;

	siteNav = document.getElementById( 'site-navigation' );
	if ( ! siteNav ) {
		return;
	}

	menuToggle = document.getElementById( 'header-menu-toggle' );
	if ( 'undefined' === typeof menuToggle ) {
		return;
	}

	menu = siteNav.getElementsByTagName( 'ul' )[ 0 ];

	// Hide menu toggle menuToggle if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		menuToggle.style.display = 'none';
		return;
	}

	menu.setAttribute( 'aria-expanded', 'false' );
	if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
		menu.className += ' nav-menu';
	}

	menuToggle.onclick = function() {
		if ( siteNav.classList.contains( 'toggled' ) ) {
			body.classList.toggle( 'nav-toggled', false );
			siteNav.classList.toggle( 'toggled', false );
			menuToggle.classList.toggle( 'toggled', false );
			siteNav.setAttribute( 'aria-expanded', 'false' );
			menu.setAttribute( 'aria-expanded', 'false' );
		} else {
			body.classList.toggle( 'nav-toggled', true );
			siteNav.classList.toggle( 'toggled', true );
			menuToggle.classList.toggle( 'toggled', true );
			siteNav.setAttribute( 'aria-expanded', 'true' );
			menu.setAttribute( 'aria-expanded', 'true' );
		}
	};

	// Get all the link elements within the menu.
	links = menu.getElementsByTagName( 'li' );

	function openSearch() {
		jQuery( 'body' )
			.removeClass( 'nav-toggled' )
			.addClass( 'search-toggled' );
		jQuery( '.header-search-input:visible' ).focus();
	}

	function closeSearch() {
		jQuery( 'body' ).removeClass( 'search-toggled' );
	}

	// Toggle search
	jQuery( 'body' ).on(
		'click', '.header-search-button', function( e ) {
			if ( jQuery( 'body.search-toggled' ).length === 0 ) {
				// If nav is currently open
				if ( jQuery( 'body.nav-toggled' ).length > 0 ) {
					// Trigger a click on the menu button to run the animation
					// TODO: for some reason the tcon transformation animation does not show at this point; being left for now as a nice-to-have as initial investigation was struggling to find a good reason why
					jQuery( '#header-menu-toggle' ).click();
				}
				openSearch();
			} else {
				closeSearch();
			}
		}
	);

	// Hide search overlay when clicking outside search bar
	jQuery( 'body' ).on(
		'click', function( event ) {
			if ( ! jQuery( event.target ).closest( '.site-header' ).length ) {
				closeSearch();
			}
		}
	);

	// Each time a menu link is focused or blurred, toggle focus.
	// for (i = 0, len = links.length; i < len; i++) {
	// 	links[i].addEventListener( 'focus', toggleFocus, true );
	// 	links[i].addEventListener( 'blur', toggleFocus, true );
	// }

	/**
	 * Sets or removes .focus class on an element.
	 */
	// function toggleFocus() {
	// 	var self = this;

	// 	// Move up through the ancestors of the current link until we hit .nav-menu.
	// 	while (-1 === self.className.indexOf( 'nav-menu' )) {
	// 		// On li elements toggle the class .focus.
	// 		if ('li' === self.tagName.toLowerCase()) {
	// 			if (-1 !== self.className.indexOf( 'focus' )) {
	// 				self.className = self.className.replace( ' focus', '' );
	// 			} else {
	// 				self.className += ' focus';
	// 			}
	// 		}

	// 		self = self.parentElement;
	// 	}
	// }

	/**
	 * Toggles `focus` class to allow submenu access on tablets.
	 *
	 * @param  siteNav
	 */
	( function( siteNav ) {
		var touchStartFn,
			i,
			parentLink = siteNav.querySelectorAll(
				'.menu-item-has-children > a, .page_item_has_children > a'
			);

		if ( 'ontouchstart' in window ) {
			touchStartFn = function( e ) {
				var menuItem = this.parentNode,
					i;

				if ( ! menuItem.classList.contains( 'focus' ) ) {
					e.preventDefault();
					for ( i = 0; i < menuItem.parentNode.children.length; ++i ) {
						if ( menuItem === menuItem.parentNode.children[ i ] ) {
							continue;
						}
						menuItem.parentNode.children[ i ].classList.remove(
							'focus'
						);
					}
					menuItem.classList.add( 'focus' );
				} else {
					menuItem.classList.remove( 'focus' );
				}
			};

			for ( i = 0; i < parentLink.length; ++i ) {
				parentLink[ i ].addEventListener(
					'touchstart',
					touchStartFn,
					false
				);
			}
		}
	}( siteNav ) );
}() );
